export default __webpack_public_path__ + "static/media/mesh_macarmour.96b83e91.png";